import React, { useRef, useEffect } from 'react'
import styled from 'styled-components'

import { animalColor, animalColorUiTheme, upperFirst } from 'global'
import { IHand } from 'models'
import { Flex, Box, IBoxProps, Card, Text, AnimalIcon } from 'components'
import textFit from 'textfit'

const ContentWrapper = styled(Box)`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  user-select: none;
`

const ColorText = styled(Text)`
  font-size: 20px;
  letter-spacing: -0.5px;
  line-height: 30px;
  font-weight: bold;
  margin-bottom: 10px;
`

const AnimalText = styled(Text)`
  font-weight: bold;
  letter-spacing: -1.5px;
  line-height: 30px;
  width: 100%;
  text-align: center;
`

interface IAnimalCard {
  animal: IHand['animal']
  handColor: IHand['color']
  children?: (animalName: string, animalColor: string) => React.ReactNode
  flipIcon?: boolean
}

export const AnimalCard = ({
  animal,
  handColor,
  children,
  flipIcon = false,
  ...props
}: IAnimalCard & IBoxProps) => {
  const uiTheme = animalColorUiTheme(handColor)
  const textRef = useRef<HTMLParagraphElement>(null)

  useEffect(() => {
    if (textRef.current) {
      textFit(textRef.current, {
        minFontSize: 28,
        maxFontSize: 60,
      })
    }
  })

  return (
    <Card
      outerProps={{ margin: 2, ...props }}
      innerProps={{ backgroundColor: animalColor(handColor) }}
    >
      <ContentWrapper>
        <Flex
          width='100%'
          height='100%'
          flexDirection='column'
          justifyContent='center'
          alignItems='center'
        >
          <AnimalIcon name={animal} width='175px' flipped={flipIcon} />
        </Flex>
        {children ? (
          children(upperFirst(animal), upperFirst(handColor))
        ) : (
          <Flex
            width='100%'
            height='100%'
            flexDirection='column'
            justifyContent='flex-start'
            alignItems='center'
          >
            <ColorText uiColorTheme={uiTheme}>
              {upperFirst(handColor)}
            </ColorText>
            <AnimalText height='100%' ref={textRef} uiColorTheme={uiTheme}>
              {upperFirst(animal)}
            </AnimalText>
          </Flex>
        )}
      </ContentWrapper>
    </Card>
  )
}
